import { Checkbox } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DebateFooter from "../../../Components/Functionality/DebateFooter";
import DebateHeader from "../../../Components/Functionality/DebateHeader";
import ImageOrInitials from "../../../Components/Functionality/ImageOrInitials";
import SelectFutureDebateOptionPopup from "../../../Components/Popup/SelectFutureDebateOptionPopup";
import SearchField from "../../../Components/UI/Inputs/SearchField";
import LoadingSpinner from "../../../Components/UI/LoadingSpinner";
import { useUserStore } from "../../../Context/store";
import { useCreateDebateContext } from "../../../Context/CreateDebateContext";
import { useSubworkspaceStore } from "../../../Context/store";
import { useWorkspaceStore } from "../../../Context/store";
import useDebounce from "../../../Services/useDebounce";
import { prepareFormData } from "../../../Utils/Helper";
import { useGetWorkspaceUserByWorkId } from "../../../Web-Hooks/Workspace/use-workspace";
import { primaryColor } from "../../../Utils/Constant";

const SelectOpponent = ({ handleBack, handleNext }) => {
  const { debateInfo, handleStateUpdate, handleDebateAndCitationAPI, isAddCitationPending, isAddDebatePending, isUpdateRedebateCountPending } = useCreateDebateContext();
  const { selectedSubWorkspace, SubWorkspaceUser, SubWorkspaceUserLoading } =
    useSubworkspaceStore();
  const { selectedWorkspace } = useWorkspaceStore();
  const { data: workspaceUser, isLoading: WorkspaceUserLoading } =
    useGetWorkspaceUserByWorkId(selectedWorkspace?.workSpaceId);
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebounce(search, 300);
  const [Users, setUsers] = useState(() =>
    debateInfo.IsDebatePublic ? workspaceUser : SubWorkspaceUser
  );
  const [contacts, setContacts] = useState([]);
  const [Publish, setPublish] = useState(false);
  const { user } = useUserStore();
  const [futureAction, setFutureAction] = useState(null);
  const location = useLocation();
  const { search: searchParams } = location;
  const query = new URLSearchParams(searchParams);
  const from = query?.get("from");
  const debateId = query?.get("debateId");
  const content = {
    headLine: "Invite Opponent",
    baseLine: "",
    pageName: "InviteMember",
  };

  const storeId = from === "Redebate" ? user?.userId : debateId ? debateId : user?.userId 


  const handlePublish = async () => {

    const formData = prepareFormData(
      debateInfo,
      selectedSubWorkspace,
      user,
      false,
      futureAction
    );

    handleDebateAndCitationAPI(formData, false,storeId, () => handleSubmit());
  };

  const handleSubmit = () => {
    setPublish(false);
    setFutureAction(null);
    localStorage.removeItem("Debate");
    localStorage.removeItem("Citation");
    localStorage.removeItem("AllCitation")
  }
  const handleChangeContacts = (value) => {
    const index = contacts.findIndex(
      (contact) => contact.label === value.email
    );
    const newContact = {
      label: value.email,
      value: value.userId,
    };
    if (index === -1) {
      setContacts([newContact]);
      handleStateUpdate({ ...debateInfo, NominateUserId: value.userId });
    } else {
      const updatedContacts = [...contacts];
      updatedContacts.splice(index, 1);
      setContacts(updatedContacts);
      handleStateUpdate({ ...debateInfo, NominateUserId: null });
    }
  };

    useEffect(() => {
      if (!debouncedSearchTerm) {
        const Debate = JSON.parse(localStorage.getItem("Debate"));
        const Users1 = Debate?.IsDebatePublic ? workspaceUser : SubWorkspaceUser;
        setUsers(Users1);
        const filterSelectedContact = Users1?.find(
          (user) => user.userId === Debate.NominateUserId
        );
        const newContact = {
          label: filterSelectedContact?.email,
          value: filterSelectedContact?.userId,
        };
        setContacts([newContact]);
        return;
      }
      const search = debouncedSearchTerm.toLowerCase();
      Users?.length &&
        setUsers(() => Users?.filter((user) => user?.email.includes(search))); // eslint-disable-next-line
    }, [debouncedSearchTerm, workspaceUser, SubWorkspaceUser]);

  return (
    <div className="flex flex-col gap-4">
      <DebateHeader content={content} />

      <div className="w-full my-2">
        <SearchField
          id="search-invite-opponent"
          name="search-invite-opponent"
          search={search}
          setSearch={setSearch}
          containerClass={"!w-full"}
        />
      </div>
      <div className="w-full border p-3 mt-2 border-debatePalette-buttonBorder rounded-md">
        <div className="flex flex-col h-96">
          {SubWorkspaceUserLoading || WorkspaceUserLoading ? (
            <LoadingSpinner color={primaryColor} />
          ) : (
            <form className="flex flex-col overflow-y-auto member-list w-full items-start gap-2">
              {Users?.map(
                (member) =>
                  member.isAccept &&
                  !member?.isUserBlock && (
                    <Checkbox
                      key={member?.email}
                      containerProps={{
                        className: "!flex items-center gap-4",
                      }}
                      checked={contacts
                        ?.map((contact) => contact?.label)
                        .includes(member?.email)}
                      onChange={() => handleChangeContacts(member)}
                      id={member?.email}
                      color="blue"
                      ripple={false}
                      className="w-4 h-4 rounded-none before:content-none"
                      label={
                        <div className="flex items-center gap-2 flex-1 w-full truncate">
                          {
                            <ImageOrInitials
                              imageSrc={member?.userImage}
                              initials={member?.userName || member?.email}
                              size={"h-10 w-10"}
                              classNameInitials={"shadow-none"}
                            />
                          }
                          <p className=" text-md first-letter:capitalize lowercase">
                            {member?.userName ||
                              member?.email?.replace(/\s+/g, "")}
                          </p>
                        </div>
                      }
                      labelProps={{
                        className:
                          "text-debatePalette-title w-full text-md font-semibold capitalize",
                      }}
                    />
                  )
              )}
            </form>
          )}
        </div>
      </div>

      <SelectFutureDebateOptionPopup
        setFutureAction={setFutureAction}
        futureAction={futureAction}
        futureActionPopup={Publish}
        setFutureActionPopup={setPublish}
        handleClose={() => {
          setPublish(false);
          setFutureAction(null);
        }}
        loading={isAddCitationPending || isAddDebatePending}
        handleSubmission={handlePublish}
      />
      <DebateFooter
        isNext={debateInfo?.NominateUserId ? false : true}
        loading={
          isAddCitationPending ||
          isAddDebatePending ||
          isUpdateRedebateCountPending
        }
        btnName={debateInfo?.IsDebatePrivate ? "Next" : "Publish"}
        handleBack={handleBack}
        handleNext={
          debateInfo?.IsDebatePrivate ? handleNext : () => setPublish(true)
        }
      />
    </div>
  );
};

export default SelectOpponent;
